import "./Question.css"
export default function(){
    return(
        <div>
            <section class="faq">
            <div class="faq1">
                <h2>سوالات متداول درباره آموزش شنا در تبریز</h2>
                <p><strong>هزینه کلاس شنا در تبریز چقدر است؟</strong>
                بسته به خصوصی یا گروهی بودن کلاس متفاوت است. برای اطلاع دقیق تماس بگیرید.</p>

                <p><strong>آیا آموزش برای بزرگسالان هم دارید؟</strong>
                بله، آموزش شنا در تبریز برای تمامی سنین ارائه می‌شود.</p>
            </div>
            </section>
        </div>
    )
}